export default "__VITE_ASSET__6cca61af__"